import React, { useState, useEffect, useRef } from 'react';
import styled from 'styled-components';
import { useMediaQuery } from 'react-responsive';

import Img from './Img';

import W from '../styled/Wrapper';

const Wrapper = styled(W)`
  position: relative;
  min-height: ${({ minH }) => (minH ? `${minH}px` : '100vh')};
  margin: 0 auto 100px;

  @media only screen and (max-width: 810px) {
    margin-bottom: 20px;
  }
`;

const Imgs = ({ locs, data }) => {
  const [minH, setMinH] = useState(false);
  const [highestZ, setHighestZ] = useState(2);
  const wrapperEl = useRef(null);

  const isMob = useMediaQuery({
    query: '(max-width: 810px)',
  });

  const checkHeights = () => {
    let lowest = 0;
    let index = 0;
    let countEl = null;

    if (wrapperEl.current) {
      Array.from(wrapperEl.current.children).map((el, i) => {
        const bottom = el.offsetTop + el.offsetHeight;

        index = bottom > lowest ? i : index;
        countEl = bottom > lowest ? el : countEl;
        lowest = bottom > lowest ? bottom : lowest;
      });
    }

    if (index === 0) {
      countEl && setMinH(countEl.offsetHeight);
    } else if (index === 1) {
      countEl && setMinH(countEl.offsetHeight + window.innerHeight * (isMob ? 0.30 : 0.3));
    } else if (index === 2) {
      countEl && setMinH(
        countEl.offsetHeight + window.innerHeight * (isMob ? 0.15 : 0.15)
      );
    }
  };

  useEffect(() => {
    checkHeights();
  }, [isMob]);

  return (
    <Wrapper minH={minH} ref={wrapperEl}>
      {locs && locs.images
        ? locs.images.map((item, i) => {
            return (
              <Img
                key={i}
                i={i}
                image={item.image}
                video={item.videoUrl}
                solo={locs.images.length === 1}
                highestZ={highestZ}
                setHighestZ={setHighestZ}
                loop={item.loop}
                checkHeights={checkHeights}
                loopWithSound={item.loopWithSound}
                poster={item.image}
              />
            );
          })
        : data.images.map((item, i) => {
            return (
              <Img
                key={i}
                i={i}
                image={item.image}
                video={item.videoUrl}
                solo={data.images.length === 1}
                highestZ={highestZ}
                setHighestZ={setHighestZ}
                loop={item.loop}
                checkHeights={checkHeights}
                loopWithSound={item.loopWithSound}
                poster={item.image}
              />
            );
          })}
    </Wrapper>
  );
};

export default Imgs;
